import { useEffect } from "react";
import { useGetCreatorDataWithCreatorIdQuery } from "../../Queries/useGetCreatorDataWithCreatorIdQuery";

const featureAvailableForCreatorIds = [
  616, 127323, 20163, 2134, 1585, 581, 518202,
];

export const useFeatureAvailableForTesting = () => {
  const { data: creatorData } = useGetCreatorDataWithCreatorIdQuery();
  const creatorId = creatorData?.id;
  const isFeatureAvailableForTesting =
    featureAvailableForCreatorIds.includes(creatorId);
  useEffect(() => {
    if (isFeatureAvailableForTesting) {
      localStorage.setItem("service_worker", "true");
    }
  }, [isFeatureAvailableForTesting]);
  return { isFeatureAvailableForTesting };
};
